var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import Radio from 'syf-component-library/ui/atoms/Radio';
import RadioGroup from 'syf-component-library/ui/patterns/RadioGroup';
import { colors } from '../../../theme';
export var PurchaseExceedsTextFieldWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 10px;\n  margin-left: 35px;\n"], ["\n  margin-top: 10px;\n  margin-left: 35px;\n"])));
export var CustomRadio = styled(Radio)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  label {\n    left: 0;\n    color: ", ";\n    &::before {\n      border-color: ", ";\n    }\n  }\n  input {\n    display: block;\n  }\n"], ["\n  label {\n    left: 0;\n    color: ", ";\n    &::before {\n      border-color: ", ";\n    }\n  }\n  input {\n    display: block;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.bodyText;
}, function (_a) {
    var hasError = _a.hasError;
    return (hasError ? colors.error : '');
});
export var CustomRadioGroup = styled(RadioGroup)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  margin-left: -5px;\n  font-size: 16px;\n"], ["\n  display: flex;\n  margin-left: -5px;\n  font-size: 16px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
